module.exports = {
  IN: '6585R',
  LK: '66769',
  BG: '67830'
}
